import {
  formsPersonnelKey,
  FORMS_CONTEXT_KEY,
} from 'src/app/forms/offline/snapshotKeys';
import {
  tasksPersonnelKey,
  TASKS_CONTEXT_KEY,
} from 'src/app/tasks/offline/snapshotKeys';

/** One cached personnel section an offline read may serve from. */
export interface PersonnelSectionSource {
  contextKey: string;
  snapshotKey: string;
}

export const FORMS_PERSONNEL_SOURCE: PersonnelSectionSource = {
  contextKey: FORMS_CONTEXT_KEY,
  snapshotKey: formsPersonnelKey,
};

export const TASKS_PERSONNEL_SOURCE: PersonnelSectionSource = {
  contextKey: TASKS_CONTEXT_KEY,
  snapshotKey: tasksPersonnelKey,
};

// Order is first-source-wins for reads: whichever ready session holds an
// in-scope section serves the personnel select box.
export const PERSONNEL_SECTION_SOURCES: PersonnelSectionSource[] = [
  FORMS_PERSONNEL_SOURCE,
  TASKS_PERSONNEL_SOURCE,
];
